import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@/components/controls/Tabs";
import { ControlProps, FieldControlValue } from "../types";
import {
  POSITIVE_BOOL_TOKENS,
  NEGATIVE_BOOL_TOKENS
} from "@/utils/fieldRendering/legacyBoolTokens";

const toTriState = (value: FieldControlValue): "yes" | "no" | "" => {
  if (value === true) return "yes";
  if (value === false) return "no";
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (POSITIVE_BOOL_TOKENS.has(normalized)) return "yes";
    if (NEGATIVE_BOOL_TOKENS.has(normalized)) return "no";
  }
  return "";
};

export const BoolControl: React.FC<ControlProps> = ({
  value,
  onChange,
  name
}) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => ({ yes: t("deals.dealView.yes"), no: t("deals.dealView.no") }),
    [t]
  );
  const currentValue = toTriState(value);

  return (
    <div className="w-fit">
      <Tabs
        options={options}
        value={currentValue}
        valueSelected={(next) =>
          onChange(next === currentValue ? undefined : next === "yes")
        }
        size="lg"
        isPositiveNegative
        dataTest={`${name}-bool`}
      />
    </div>
  );
};
